
























































import { Component, Vue, Mixins } from 'vue-property-decorator'
import StudentHistorySidebar from '@/components/organisms/StudentHistorySidebar.vue'
import SeminarTeacherHistoryHeader from '@/components/organisms/SeminarTeacherHistoryHeader.vue'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import SelectSubject from '@/components/atoms/SelectSubject.vue'
import TitleBase from '@/components/atoms/TitleBase.vue'
import TitleTextBase from '@/components/atoms/TitleTextBase.vue'
import SelectPeriod from '@/components/organisms/SelectPeriod.vue'
import ChartLineUnderstandingRelative, { ChartRecord } from '@/components/atoms/ChartLineUnderstandingRelative.vue'
import AccordionStudentHistory, { GradeHistories } from '@/components/organisms/AccordionStudentHistory.vue'
import SubjectSituationWebApi from '@/mixins/history/SubjectSituationWebApi'
import LoadEnableSubjectsApi from '@/mixins/utils/LoadEnableSubjectsApi'
import SelectBase from '@/components/atoms/SelectBase.vue'
import TeacherHistoryBottomPanel from '@/components/organisms/TeacherHistoryBottomPanel.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

@Component({
  components: {
    StudentHistorySidebar,
    SeminarTeacherHistoryHeader,
    ColoredBox,
    ChartLineUnderstandingRelative,
    SelectSubject,
    TitleBase,
    TitleTextBase,
    SelectPeriod,
    AccordionStudentHistory,
    SelectBase,
    TeacherHistoryBottomPanel,
    ButtonBase,
  },
})
export default class SubjectSituation extends Mixins(SubjectSituationWebApi, LoadEnableSubjectsApi) {
  // クラスモード: 講習会
  private readonly classMode = 'KS'

  private selectedSubject = this.$route.query.selectedSubject ? String(this.$route.query.selectedSubject) : ''

  // 教科プルダウン表示対象、教科コードの配列 ex.=> ['su', 'ei', 'ko']
  private enableSubjects: string[] = []

  private selectSeminarOptions: { text: string; value: string }[] = []

  private selectedTerm = ''

  private hasSeasonDate = true

  private get branchId() {
    return Vue.prototype.$cookies.get('dataGdls').branchId
  }

  private get studentUserId() {
    return Vue.prototype.$cookies.get('dataGdls').student?.userId || 0
  }

  private get enableSelectedSubject() {
    return this.enableSubjects.includes(this.selectedSubject) ? this.selectedSubject : ''
  }

  // チャートデータ
  private chartDatas: ChartRecord[] = []

  // 学習結果
  private result = {
    questionCount: 0,
    correctCount: 0,
    hour: 0,
    minute: 0,
  }

  // 表示日付
  private dateSteps: string[] = []

  // 項目毎の累計理解度 rateの位置は最大値の位置で表示する
  private gradeHistories: GradeHistories[] = []

  private async mounted() {
    if (this.studentUserId === 0) return
    Vue.prototype.$loading.start()
    await this.getSeasonSettingsSeasons()
    if (this.hasSeasonDate) {
      await this.loadEnableSubjects()
      await this.loadChartRecords()
      await this.loadGradeHistories()
    }
    Vue.prototype.$loading.complete()
  }

  // 期間プルダウン変更時
  private async onChangeTerm() {
    Vue.prototype.$loading.start()
    await this.loadChartRecords()
    await this.loadGradeHistories()
    Vue.prototype.$loading.complete()
  }

  // 教科プルダウン変更時
  private async onChangeSubject() {
    Vue.prototype.$loading.start()
    await this.loadChartRecords()
    await this.loadGradeHistories()
    Vue.prototype.$loading.complete()
  }

  /**
   * チャート情報取得
   */
  private async loadChartRecords() {
    if (this.selectedSubject == '') return

    const { chartDatas, result, dateSteps } = await this.loadChartRecordsApi({
      userId: this.studentUserId,
      term: this.selectedTerm,
      subjectCode: this.selectedSubject,
      classMode: this.classMode,
    })
    // チャート用のスコア配列をセット
    this.chartDatas = chartDatas
    // 学習結果セット
    this.result = result
    // 表示日付セット
    this.dateSteps = dateSteps
  }

  /**
   * 項目毎の理解度取得
   */
  private async loadGradeHistories() {
    if (this.selectedSubject == '') return

    const result = await this.loadGradeHistoriesApi({
      userId: this.studentUserId,
      subjectCode: this.selectedSubject,
      classMode: this.classMode,
      term: this.selectedTerm,
    })
    // 項目毎の累計理解度セット
    this.gradeHistories = result['curriculums']
  }

  /**
   * サービス設定で有効な教科を取得し、教科プルダウンに反映
   */
  private async loadEnableSubjects() {
    // プルダウン候補の取得
    this.enableSubjects = (await this.loadGdlsSubjectsApi(this.branchId, this.studentUserId)).map((subject) => {
      return subject.code
    })
    // デフォルトの教科セット
    this.selectedSubject = this.selectedSubject === '' ? this.enableSubjects[0] : this.selectedSubject
  }

  // 講習会期間プルダウン生成
  private async getSeasonSettingsSeasons() {
    await Vue.prototype.$http.httpWithToken
      .get('/seasonSettings/seasons', { params: { userId: this.studentUserId } })
      .then((res: any) => {
        if (res.data.length === 0) {
          this.hasSeasonDate = false
          return
        }
        this.selectSeminarOptions = res.data.map((season: { id: string; gradeName: string; seasonName: string }) => {
          return { text: `${season.gradeName} ${season.seasonName}`, value: season.id }
        })
        const selectedIndex = res.data.findIndex((season: { isSelected: boolean }) => {
          return season.isSelected === true
        })
        const selected = res.data[selectedIndex]
        this.selectedTerm = selected.id
      })
  }
}
